<template>
  <el-form
    :model="card_data"
    :rules="cardRules"
    ref="cardRef"
    label-width="180px"
    label-position="right"
    style="padding:20px 0 20px 0"
  >
    <el-form-item label="会员卡名：" prop="card_name">
      <el-input v-model="card_data.card_name"></el-input>
      <span style="display:inline-block;margin-left:20px">
        设置会员卡名称
      </span>
    </el-form-item>
    <el-form-item label="店铺号：" prop="mch_no">
      <el-input v-model="card_data.mch_no"></el-input>
      <span style="display:inline-block;margin-left:20px">
        设置店铺号
      </span>
    </el-form-item>
    <el-form-item label="令牌：" prop="access_token">
      <el-input v-model="card_data.access_token"></el-input>
      <span style="display:inline-block;margin-left:20px">
        服务商令牌，验证创建会员卡的权限。
      </span>
    </el-form-item>
    <el-form-item label="是否支持积分："
      ><el-radio-group v-model="card_data.supply_bonus">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
      <span style="display:inline-block;margin-left:20px">
        设置该类型的优惠卷是否支持积分功能。
      </span>
    </el-form-item>
    <el-form-item label="是否支持储值："
      ><el-radio-group v-model="card_data.supply_balance">
        <el-radio :label="true">是</el-radio>
        <el-radio :label="false">否</el-radio>
      </el-radio-group>
      <span style="display:inline-block;margin-left:20px">
        设置该类型的优惠卷是否支持储值功能。
      </span>
    </el-form-item>
    <el-form-item label="使用说明：" prop="detail">
      <el-input
        type="textarea"
        :rows="4"
        style="width:300px"
        v-model="card_data.detail"
      ></el-input>
      <br />
      <span style="display:inline-block;margin-left:20px">
        注：如示例，用于介绍会员卡注意点。
      </span>
    </el-form-item>
    <el-form-item label="使用提示：" prop="prerogative">
      <el-input
        type="textarea"
        :rows="4"
        style="width:300px;display:inline-block"
        v-model="card_data.prerogative"
      ></el-input>
      <br />
      <span style="display:inline-block;margin-left:20px;">
        注：如示例，用于介绍会员卡使用提示。
      </span>
    </el-form-item>
    <el-form-item label="背景图片：">
      <logo
        :wh="
          'height:160px;width:288.9px;background-color:#80c4ff;font-size:20px;'
        "
        :tag="'bg'"
        :uploadCommon="true"
        @getReturn="getReturn"
        @returnClose="returnClose"
      >
        <div style="height:160px;width:288.9px'">
          上传背景图
        </div>
      </logo>
    </el-form-item>
  </el-form>
</template>
<script>
import logo from "./logo.vue";
export default {
  name: "cardForm",
  components: {
    logo
  },
  data() {
    return {
      card_data: {
        supply_bonus: true, //支持积分
        supply_balance: true, //支持存储
        card_name: "",
        mch_no: "",
        detail: "领卡可享积分优惠卷活动",
        prerogative: "付款提前出示卡卷",
        access_token: "",
        background_pic: ""
      },
      cardRules: {
        card_name: [{ required: true, message: "请输入卡名", trigger: "blur" }],
        mch_no: [{ required: true, message: "请输入店铺号", trigger: "blur" }],
        detail: [{ required: true, message: "请输入卡说明", trigger: "blur" }],
        prerogative: [
          { required: true, message: "请输入提示", trigger: "blur" }
        ],
        access_token: [
          { required: true, message: "请输入创建卡令牌", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  mounted() {},
  methods: {
    //上传图片返回
    getReturn(res) {
      this.card_data.background_pic =
        this.$url + "media/image/" + res.media_no + ".jpg";
    },
    //删除图片返回
    returnClose(res) {
      // console.log("删除图片返回",res)
    },
    createCard() {
      var that = this;
      this.$refs.cardRef.validate(async result => {
        if (result === true) {
          const access_token = that.card_data.access_token;
          that.card_data.access_token = await that.$encrypt(
            that.card_data.access_token
          );
          // var res = await GenerateCardClasify(JSON.stringify(that.card_data));
          //TODO： index。js 没用了
          /* if (testRes(res, "创建成功")) {
            var resp = await GenerateWxCard({
              card_id: res.data.resp_data.card_id
            });
            testRes(resp, "绑定wx卡成功");
          } else {
            return;
          } */
          that.card_data.access_token = access_token;
        }
      });
      /*  */
    }
  }
};
</script>
<style scoped>
.el-form {
  color: #9d9fa5;
}
#date-div >>> .el-input {
  width: 200px !important;
}
.el-form-item >>> .el-input {
  width: 300px !important;
}
.el-divider--horizontal {
  height: 0.1px;
  margin-top: 5px !important;
  margin-right: 30px !important;
  margin-bottom: 0 !important;
}
</style>
